"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const class_transformer_1 = require("class-transformer");
const FileResponseResource_1 = __importDefault(require("../../../../File/FileResponseResource"));
const I18nTextResource_1 = require("../../../../I18nText/I18nTextResource");
const ContributorResponseResource_1 = __importDefault(require("../../Contributor/ContributorResponseResource"));
const ProjectTeamResponseResource_1 = __importDefault(require("../ProjectTeamResponseResource"));
const Resource_1 = __importDefault(require("../../../../Resource"));
class ProjectTeamCastResponseResource extends Resource_1.default {
}
exports.default = ProjectTeamCastResponseResource;
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ProjectTeamCastResponseResource.prototype, "id", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => I18nTextResource_1.I18nTextResource),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], ProjectTeamCastResponseResource.prototype, "characterName", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => ContributorResponseResource_1.default),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", ContributorResponseResource_1.default)
], ProjectTeamCastResponseResource.prototype, "actor", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => ProjectTeamResponseResource_1.default),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", ProjectTeamResponseResource_1.default)
], ProjectTeamCastResponseResource.prototype, "projectTeam", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => FileResponseResource_1.default),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ProjectTeamCastResponseResource.prototype, "image", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Date),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ProjectTeamCastResponseResource.prototype, "createdAt", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Date),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ProjectTeamCastResponseResource.prototype, "updatedAt", void 0);
